import { render, staticRenderFns } from "./mobUserBar.vue?vue&type=template&id=7480e064&scoped=true"
import script from "./mobUserBar.vue?vue&type=script&lang=ts"
export * from "./mobUserBar.vue?vue&type=script&lang=ts"
import style0 from "./mobUserBar.vue?vue&type=style&index=0&id=7480e064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480e064",
  null
  
)

export default component.exports